import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import PieChart from '../../components/pie-chart'
import TeamUp from '../../components/teamup'
import Ezfacility from '../../components/ezfacility'
import { AuthContext } from '../../../../auth-context'
import { DashboardContext } from '../../dashboard-context'
import ClientTable from './components/client-table'
import AlertTable from './components/alert-table'
import { getAttentionSettings } from './components/alert-table-settings'
import { updatePortalUser } from '../../../../api'
import { Toggle } from './components/toggle'
import { Calendar } from './components/calendar'
import VideoPlayer from '../videos/video-player'

const ToggleSeparator = styled.div`
  margin: 12px 0px;
  @media (max-width: 900px) {
    margin: 0px 0px;
  }
`;

const GridContainer = styled.div`
  padding: 32px 16px 200px 16px;
  margin: 0 auto;
  max-width: 1440px;
`;

const Grid = styled.div`
  display: flex;
  margin: 0 auto;
  @media(max-width: 1420px) {
    flex-direction: column-reverse;
  }

  >div:nth-child(1) {
    margin-right: 8px;
    flex-shrink: 2;
    @media(max-width: 1420px) {
      margin-right: 0px;
    }
  }

  >div:nth-child(2) {
    margin-left: 8px;
    flex-shrink: 0;
    @media(max-width: 1420px) {
      margin: 0px 0px 24px 0px;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const TrainerName = styled.h1`
`;

const BackText = styled.h3`
  color: #4CB050;
  cursor: pointer;
`
const GroupSelect = styled(Select)`
  padding: 7px 12px;
  width: 500px;
  margin-bottom: 16px;
  border-radius: 100px;
  background-color: #eaedf5;
  color: #5a5a5a !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 16px !important;
  font-weight: 300 !important;
  &.Mui-focused .MuiSelect-select {
    background-color: #eaedf5;
  }
  &:before {
    border: none !important;
  }
  &:after {
    border: none !important;
  }
`

const avatarWelcomeVideo = {
  "title": "Portal Welcome Video",
  "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Avatar+Portal+Welcome+Video.mp4",
  "length": "2:54"   
}

const fbbcWelcomeVideo = {
  "title": "Portal Welcome Video",
  "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Fit+Body+Nutrition+Welcome+Video.mp4",
  "length": "2:39"   
}

const Dashboard = () => {
  const { user, updateUser } = useContext(AuthContext);
  const { filterGroupID, setFilterGroupID, clientsTrainerID, setClientsTrainerID } = React.useContext(DashboardContext);
  const [showGroupFilter, setShowGroupFilter] = useState(false)
  const attentionSettings = getAttentionSettings(user.attention_settings)
  const [showVideo, setShowVideo] = useState(false)

  useEffect(() => {
    if (!user?.tutorials?.portal_welcome_video) {
      setShowVideo(true)
    }
  }, [user.tutorials])

  const handleVideoClose = () => {
    setShowVideo(false)
    let newTutorials = {...user.tutorials}
    newTutorials['portal_welcome_video'] = 1
    const newUser = Object.assign({}, user, { tutorials: newTutorials })
    updateUser(newUser)
    updatePortalUser(user.id, { tutorials: JSON.stringify(newTutorials) }).then((res) => {
    }).catch((err) => {
      console.log(err)
    })
  }

  const handleFilterGroupIDChange = (e) => {
    setFilterGroupID(Number(e.target.value))
  }

  const handleChange = () => {
    if (clientsTrainerID === '')
      setClientsTrainerID(user.id)
    else
      setClientsTrainerID('')
  }

  const toggleDailyEmail = () => {
    let newSettings = {...attentionSettings}
    newSettings.email = 1 - newSettings.email
    const newUser = Object.assign({}, user, { attention_settings: newSettings })
    updateUser(newUser)
    updatePortalUser(user.id, { attention_settings: JSON.stringify(newSettings) }).then((res) => {
    }).catch((err) => {
      console.log(err)
    })
  }

  let trainerName = ''
  
  if (clientsTrainerID !== user.id && clientsTrainerID !== '') {
    const trainerIndex = user.team.findIndex(u => u.id === clientsTrainerID);
    trainerName = user.team[trainerIndex].name
  }
  return (
    <>
      <GridContainer>
        {showGroupFilter &&
          <div>
            <InputLabel id="filter-group-select-label" style={{color: '#676767', fontFamily: '"DM Sans", sans-serif', fontSize: '14px', fontWeight: '700', marginBottom: '8px'}}>Group Filter</InputLabel>
            <GroupSelect value={filterGroupID} labelId="filter-group-select-label" label="Group Filter" disableUnderline onChange={handleFilterGroupIDChange}>
              <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={0}>(no filter)</MenuItem>
              {user.groups.map((entry, index) => (
                <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} key={index} value={entry.id}>{entry.name}</MenuItem>
              ))}
            </GroupSelect>
          </div>
        }
        {(user.role_id === 1 || user.role_id === 2) &&
          <>
            <Toggle
              label="Show all clients (admin only)"
              checked={clientsTrainerID === ''}
              onChange={handleChange}
            />
            <ToggleSeparator />
          </>
        }
        <Toggle
          label="Send daily email"
          checked={attentionSettings.email}
          onChange={toggleDailyEmail}
        />
        <div style={{height: '24px'}} />
        {clientsTrainerID !== '' &&
          <Wrapper>
            <TrainerName>{user.id === clientsTrainerID ? 'My Assigned Clients' : `${trainerName}'s Clients`}</TrainerName>
            {user.id !== clientsTrainerID && <BackText onClick={() => setClientsTrainerID(user.id)}>Back to my clients</BackText>}
          </Wrapper>
        }
        <Grid>
          <AlertTable />
          <PieChart />
        </Grid>
        <div style={{height: '24px'}}></div>
        <ClientTable showGroupFilter={showGroupFilter} setShowGroupFilter={setShowGroupFilter} />
        <div style={{height: '24px'}}></div>
        <Calendar />
        <div style={{height: '24px'}}></div>
        {user.use_teamup === 1 &&
          <TeamUp />
        }
        <div style={{height: '24px'}}></div>
        {user.use_ezfacility === 1 &&
          <Ezfacility />
        }
      </GridContainer>
      <VideoPlayer
        video={user.branch === 0 ? avatarWelcomeVideo : fbbcWelcomeVideo}
        open={showVideo}
        onClose={() => handleVideoClose()}
      />      
    </>
  )
}

export default Dashboard